import React, { useState, useEffect } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';
import { Typeahead } from 'react-bootstrap-typeahead';

import request from '../../../../../utils/request';
import { sortedObjects } from '../../../../../utils/utils';
import Label from './common/label';

const Dealership = ({ fieldData, setFieldData, formErrors, setFormErrors }) => {
  const [dealershipList, setDealershipList] = useState([]);
  const [defaultDealership, setDefaultDealership] = useState('');

  const fieldError = 'dealership' in formErrors;

  useEffect(() => {
    (async () => {
      const result = await request.get('/dealerships');
      const updatesList = sortedObjects(
        result.data.rows,
        'name'
      ).map(({ name }) => ({ id: name, label: name }));

      if (fieldData.dealership) {
        const selectedValue = result.data.rows.find(
          dealership => dealership.id === fieldData.dealership
        );
        setDefaultDealership([selectedValue.name]);
      }

      setDealershipList(updatesList);
    })();

    return () => {
      setFieldData(previousValue => ({ ...previousValue, dealership: null }));
    };
  }, []);

  return (
    <>
      {dealershipList && (
        <div className={fieldError ? 'field-error' : ''}>
          <Label labelName="Dealership *" />
          {fieldError && (
            <div className="error-notification">
              <p>{formErrors.dealership.message}</p>
            </div>
          )}
          <div
            style={{
              position: 'relative',
              width: '100%',
              marginBottom: '-2rem'
            }}
            className="frg-select-container color-light input-container"
          >
            <Typeahead
              id="Dealership"
              labelKey="label"
              options={dealershipList}
              onChange={value => {
                if (!value.length)
                  setFormErrors({
                    ...formErrors,
                    dealership: { message: 'Field is required' }
                  });
                else {
                  const errors = { ...formErrors };
                  delete errors.dealership;
                  setFormErrors({
                    ...errors
                  });
                }

                setFieldData(previousValue => ({
                  ...previousValue,
                  dealership: [_.get(value, '0.id', '')]
                }));
              }}
              placeholder="Please select..."
              selected={defaultDealership}
              clearButton
            />
          </div>
        </div>
      )}
    </>
  );
};

Dealership.propTypes = {
  formErrors: PropTypes.shape({
    dealership: PropTypes.shape({
      message: PropTypes.string
    })
  }).isRequired,
  setFormErrors: PropTypes.func.isRequired,
  setFieldData: PropTypes.func.isRequired,
  fieldData: PropTypes.shape({
    role: PropTypes.number,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    contactNumber: PropTypes.string,
    provinces: PropTypes.arrayOf(PropTypes.string),
    channels: PropTypes.arrayOf(PropTypes.string),
    outlet: PropTypes.string,
    cpmsId: PropTypes.string,
    xid: PropTypes.string,
    storeCode: PropTypes.string,
    dealership: PropTypes.arrayOf(PropTypes.string),
    channelOrgCode: PropTypes.string,
    salesManager: PropTypes.string,
    salesManagerEmail: PropTypes.string
  }).isRequired
};

export default Dealership;
